import React, { Component } from 'react';
import "./eventshow.css"
import Moment from 'react-moment'
class Eventshow extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading : false,
            noticeMassage : "",
            noerorrpage :  true,
            domain: 'https://uvune-events.herokuapp.com',
            eventData : []
        }
    }


    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        // const { match: { params } } = this.props;
        // console.log("data, params", this.params)
        const { match: { params } } = this.props;
     console.log("params.userId",params.id, "params all", params)

        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
        };
        this.setState({
         loading:true
        })
        // console.log("public users param", params.id, this.props.location.state, this.props.location.state.message)
        fetch(this.state.domain+"/payment-item/"+params.id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
              console.log("public this.slugify", result.featured_image_url)
            this.setState({
            //    frinedUrl: this.slugify(result.name)
                eventData:result
            })
            // console.log("public this.slugify", this.slugify(result.name))
        
          }).catch( (error) => {
            console.log("errro", error);
            this.setState({
                errorend  : true,
                noticeMassage : "Not update",
            })   
         });
        console.log("data", )
    } 
  render() {
      
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
    return (


        <div className="event-public-mean"> 
                {
                    this.state.eventData?
                    <div> 
                        {
                            this.state.eventData.featured_image_url ?
                            <div>
                                <div id="ehead">
                                    <div className="event-public-mean-sub" style={{backgroundImage: "url(" +  this.state.eventData.featured_image_url + ")", "width": "100%","background-blend-mode": "difference"}}> 
                                    </div>
                                        <div className="columns">
                                                <div className="column is-two-thirds">
                                                 
                                                        <div className="event-public-image-body" style={{backgroundImage: "url(" +  this.state.eventData.featured_image_url + ")"  }}>
                                                        {/* kjgnbklj */}
                                                        {/* <div className="event-public-title-body">  
                                                        </div> */}
                                                        </div>
                                                </div>
                                                <div className="column">
                                                    <div className="event-public-title-info">
                                                       <p className="event-public-title-para">
                                                          <i className="fas fa-calendar-alt event-public-title-iocn"></i>  
                                                          <Moment  format="LL" date={this.state.eventData.createdAt} />
                                                       </p>   
                                                       <hr className="event-public-title-hr" />
                                                       <h4 className="event-public-title-h4"><b>judge name</b></h4>
                                                       <br/>
                                                       <p className="event-public-title-p">by Pride Magazine Nigeria</p>
                                                    </div>   
                                               
                                                </div>
                                             
                                        </div>

                
                                </div>
                                
                            </div>

                           
                           
                             :
                             <p></p> 
                        }
                         {/* <div className="event-public-mean-">
                                    kjrjyn;lkh
                        </div> */}
                        
                     </div>
                    
                  :
                    <p></p>
                }
                          
                   <div className="event-public-mean-data">
                        <div className="event-public-mean-data-sub">
                           <div className="event-public-mean-registar">
                           <a class="button is-link event-public-registar-buttom">Register</a>
                           </div>
                           <div className="event-public-description-body">
                            <div>
                            <div className="columns">
                                <div className="column is-two-thirds">
                                   <h4 className="event-public-description-h4">Description</h4>
                                   <div className="event-public-description-para">
                                        The conference aims to outline strategic objectives and actions for the 
                                        emotional and material wellbeing of 
                                        the 21st century woman, her family and the society. This in an agenda
                                            for women empowerment because an emotionally balanced woman is a dynamo
                                     for successful personal achievement, a happy home, well-balanced children 
                                     and an enhanced society.

                                        The conference will be an interactive one where speakers and audience share 
                                        their experiences in order to help the modern woman
                                        cope with the challenges of work, relationships and family in the 21st Century.
                                   </div>
                                  
                                   
                                </div>
                                <div className="column">
                                <div class="event-details hide-small">
								<h3 class="label-primary l-mar-bot-2" data-automation="listing-info-language">Date and Time</h3>
								<div class="event-details__data">
								
									<time class="clrfix" data-automation="event-details-time">
											<p>Fri, May 24, 2019</p>
											<p>9:00 AM – 4:00 PM WAT</p>
											<p class="hide-small hide-medium">
												<a class="js-add-to-calendar-modal js-d-dialog-trigger" href="#add-to-calendar-modal" data-automation="add-to-calendar" role="button" aria-haspopup="true" dorsal-guid="9e6b4699-536a-c248-5e7b-729b3f7b0d17" data-xd-wired="dialog-trigger">Add to Calendar</a>
											</p>
									</time>
								</div>
							<h3 class="label-primary l-mar-bot-2">Location</h3>
							<div class="event-details__data">
                                            <p>NIGERIAN INSTITUTE OF INTERNATIONAL AFFAIRS (NIIA)</p>
                                                <p>13/15 KOFO ABAYOMI STREET </p>
                                                <p>VICTORIA ISLAND, LAGOS 101241 </p>
                                            <p>
                                                <a class="js-d-scroll-to js-scroll-to-map" href="#map-target" data-d-duration="1500" data-d-destination="#map-target" dorsal-guid="6cc96680-7c93-c71c-100b-6e922db1b924" data-xd-wired="scroll-to">View Map</a>
                                                <a class="js-view-map-link is-hidden" href="" target="_blank">View Map</a>
                                            </p>
                                        </div>
                                </div>
                                </div>
                             </div>

                            </div>
                            <div>
                                
                                <h4 className="event-public-description-h4"> Share With Friends </h4>
                                    <ul id="event-public-description-dot-boy">
                                    <li>
                                        <span className="event-public-description-dot">
                                            <i className="fab fa-facebook-f"></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span className="event-public-description-dot">
                                                <i className="fab fa-twitter"></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span className="event-public-description-dot">
                                        <i className="fab fa-linkedin-in"></i>
                                        </span>
                                    </li>
                                    <li>
                                        <span className="event-public-description-dot">
                                            <i className="fas fa-envelope"></i>
                                        </span>
                                    </li>
                                    
                                </ul>
                                
                            </div>
                            <div className="event-public-mean-organizer">
                                <div className="event-public-organizer-sub">
                                    <h3 className="event-public-organizer-h3">Pride Magazine Nigeria</h3>
                                    <h6>Organizer of PRIDE WOMEN CONFERENCE 2019</h6>
                                </div>
                                    
                                <ul id="event-public-organizerdot-body">
                                        <li>
                                            <span className="event-public-mean-organizer-dot">
                                               
                                                <i className="fas fa-link"></i>

                                            </span>
                                            Website
                                        </li>
                                        <li>
                                            <span className="event-public-mean-organizer-dot">
                                                    
                                                    <i className="fab fa-facebook-f"></i> 
                                            </span>
                                            PrideConference
                                        </li>
                                        <li>
                                            <span className="event-public-mean-organizer-dot">
                                            <i className="fab fa-twitter"></i> 
                                            </span>
                                            PrideConference
                                        </li>
                                   
                                        
                                    </ul>
                            </div>
                            <div>
                                
                                
                            </div>
                                
                           
                           </div>
           
	
		<div>
			<ul class="grouped-ico">
				<li>
					<a href="https://maps.google.com?saddr=Current+Location&amp;daddr=6.435705,3.4134851000000026&amp;driving" target="_blank" class="btn btn--target is-collapsed js-drive-directions-link btn--invert" title="View directions by car in Google Maps">
						<i class="ico-car"></i><span class="btn--context">By Car</span>
					</a>
				</li>
				<li>
					<a href="https://maps.google.com?saddr=Current+Location&amp;dirflg=w&amp;daddr=6.435705,3.4134851000000026" target="_blank" class="btn btn--target is-collapsed js-walk-directions-link btn--invert" title="View walking directions in Google Maps">
						<i class="ico-walking"></i><span class="btn--context">Walking</span>
					</a>
				</li>
				<li>
					<a href="https://maps.google.com?saddr=Current+Location&amp;dirflg=r&amp;daddr=6.435705,3.4134851000000026&amp;mode=transit" target="_blank" class="btn btn--target is-collapsed js-transit-directions-link btn--invert" title="View directions by public transportation in Google Maps">
						<i class="ico-public-transit"></i><span class="btn--context">Public Transport</span>
					</a>
				</li>
				<li>
					<a href="https://maps.google.com?saddr=Current+Location&amp;dirflg=b&amp;daddr=6.435705,3.4134851000000026&amp;mode=bicycling" target="_blank" class="btn btn--target is-collapsed js-bike-directions-link btn--invert" title="View directions by bike in Google Maps">
						<i class="ico-bike"></i><span class="btn--context">Bike</span>
					</a>
				</li>
			</ul>
		</div>



                        </div>
                   </div>       
     
        </div>



    
    )

  }

}
export default  Eventshow


// WEBPACK FOOTER //
// ./src/component/eventshow/eventshow.js